// src/common/CompanyContext.js
import React, { createContext, useState, useContext } from 'react';

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [selectedCompany, setSelectedCompany] = useState(null);

  // You might want to persist the selection in localStorage
  const updateSelectedCompany = (companyGuid) => {
    setSelectedCompany(companyGuid);
    localStorage.setItem('selectedCompany', companyGuid);
  };

  // Initialize from localStorage if available
  React.useEffect(() => {
    const savedCompany = localStorage.getItem('selectedCompany');
    if (savedCompany) {
      setSelectedCompany(savedCompany);
    }
  }, []);

  return (
    <CompanyContext.Provider value={{ 
      selectedCompany, 
      setSelectedCompany: updateSelectedCompany 
    }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};